import { makeAutoObservable } from "mobx";
import UserServerClient from "../ServerClients/UserServerClient";
import { UserObservableRequestApi } from "../DTO/User";
import { AppStoreApi } from "./AppStore";

export class AuthStore {
  isAuth = false;
  root: AppStoreApi;

  constructor(root: AppStoreApi) {
    this.root = root;
    makeAutoObservable(this, {}, { autoBind: true });
  }

  private setAuth(value: boolean) {
    this.isAuth = value;
  }

  async loginUserAsync(user: UserObservableRequestApi): Promise<boolean> {
    return UserServerClient.sendToLoginUserAsync(user)
      .then(() => {
        return UserServerClient.sendToGetUserAsync();
      })
      .then((userData) => {
        this.root.userStore.setUser(userData!);
        this.setAuth(true);
        return this.isAuth;
      })
      .catch((err) => {
        this.setAuth(false);
        throw err;
      });
  }

  async checkAuthAsync(): Promise<boolean> {
    console.log("check auth");
    return UserServerClient.sendToGetUserAsync()
      .then((userData) => {
        this.root.userStore.setUser(userData!);
        this.setAuth(true);
        return this.isAuth;
      })
      .catch((err) => {
        console.log("login error");
        this.setAuth(false);
        return this.isAuth;
      });
  }

  async logout() {
    try {
      this.isAuth = false;
      this.root.userStore.logout();
      UserServerClient.sendToLogoutUserAsync();
    } catch (err) {
      this.isAuth = true;
      console.log("logout error");
    }
  }
}
